interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(current - 2, total - 4));
  const end = Math.min(total, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300/70 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-600 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/70 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-sm text-foreground-700 transition-colors hover:border-primary-600 hover:text-primary-300"
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-500">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`flex h-9 w-9 items-center justify-center rounded-md border text-sm transition-colors ${
            p === current
              ? 'border-primary-500 bg-primary-500 font-semibold text-foreground-950'
              : 'border-background-300/70 text-foreground-700 hover:border-primary-600 hover:text-primary-300'
          }`}
        >
          {p}
        </button>
      ))}

      {end < total && (
        <>
          {end < total - 1 && <span className="px-1 text-foreground-500">…</span>}
          <button
            type="button"
            onClick={() => onChange(total)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-sm text-foreground-700 transition-colors hover:border-primary-600 hover:text-primary-300"
          >
            {total}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300/70 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-600 hover:text-primary-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/70 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}